import { Button, Card, Modal, Row } from 'antd';
import { DEMO_DOMAIN } from 'config/api-variables';
import React, { useState } from 'react';
import { isMobile } from 'react-device-detect';
import {
  getIsDemoFormFilled,
  setIsDemoFormFilled,
} from 'utils/local-storage/user';
import ContactForm from '../ContactForm';
import { useNavigate } from 'react-router-dom';

export default function DemoButtons({ height = 38, extraDivStyles }) {
  const navigate = useNavigate();

  const [isDemoFormVisible, setDemoFormVisible] = useState(false);

  const demoButtonClicked = () => {
    if (getIsDemoFormFilled()) {
      window.open(DEMO_DOMAIN, '_blank');
    } else {
      setDemoFormVisible(true);
    }
  };

  return (
    <>
      <Row
        gutter={24}
        style={{
          width: '100%',
          // marginLeft: 0,
          margin: '12px',
          marginBottom: isMobile && '4vmin',
          ...extraDivStyles,
        }}
        // justify={isMobile && 'center'}
        justify="start"
      >
        <Button
          style={{
            backgroundColor: '#000',
            color: '#fff',
            height: height,
            borderRadius: '4px',
            margin: '12px',
            // fontSize: '1.2rem',
          }}
          onClick={() => navigate('/signup')}
          // onClick={demoButtonClicked}
        >
          SignUp Free
        </Button>

        <Button
          style={{
            backgroundColor: '#fff',
            color: '#000',
            height: height,
            margin: '12px',
            borderRadius: '4px',
            // fontSize: '1.2rem',
          }}
          onClick={() => navigate('/contact-us')}
          // onClick={demoButtonClicked}
        >
          Request Demo
        </Button>

        {/* <Button
          type="primary"
          style={{
            backgroundColor: 'transparent',
            color: '#fff',
            marginLeft: '20px',
            // height: '50px',
            borderColor: '#fff',
            borderRadius: '8px',
            // fontSize: '1.2rem',
          }}
          onClick={demoButtonClicked}
        >
          Live Demo
        </Button> */}
      </Row>

      <Modal
        open={isDemoFormVisible}
        onCancel={() => setDemoFormVisible(false)}
        title="Request live demo"
        // closable={false}
        footer={null}
        destroyOnClose
      >
        <Card>
          <ContactForm
            isForDemo={true}
            demoFormSubmitted={shouldUpdate => {
              setIsDemoFormFilled(shouldUpdate);
              setDemoFormVisible(false);
              window.open(DEMO_DOMAIN, '_blank');
            }}
          />
        </Card>
      </Modal>
    </>
  );
}
